import { Component, OnInit } from '@angular/core';
import { HsgSubNavService } from '@hhsg/hsg-asc';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Constants } from '../../../../shared/utilities/constants.util';
import { PermissionsService } from '../../../../shared/services/permissions.service';
import { RouteUtil } from '../../../../shared/utilities/route.util';
import { SubItemLink } from '../../../../shared/models/sub-itemlink.model';
import { UserPermissions } from '../../../../shared/models/user-permissions.model';
import { UserService } from '../../../../shared/services/user.service';

@Component({
  selector: 'smt-import',
  templateUrl: './import.component.html',
  styleUrls: ['./../admin.component.scss']
})
export class ImportComponent implements OnInit {
    user: UserPermissions = null;
    links: SubItemLink[] = [];

    private _unsubscribe$ = new Subject();

    constructor(private subNav: HsgSubNavService, private permissionsService: PermissionsService, private userService: UserService) { 
        this.subNav.setSubNavData({
            title: "Imports",
            links: this.links
        });
    }

    async ngOnInit() {
        this.permissionsService.userPermissions$
            .pipe(takeUntil(this._unsubscribe$))
			.subscribe((user: UserPermissions) => {
				this.user = user;
            });

        if (!this.user) {
            let userPermissions = await this.userService.getUserPermissions();

            if (userPermissions) {
                this.permissionsService.announceUserPermissions(userPermissions);
            }
        }

        Constants.ImportPages.forEach((page) => {
            let pageName = page[0];
            let displayName = page[2];
            if (RouteUtil.isPageViewable(this.user, pageName)) {
                this.links.push({ href: RouteUtil.findPageRoute(this.user, pageName), name: displayName });
            }
        });
    }
}
